import { formatCurrency, booleanStringIsTruthy } from 'lib/helpers'
import {
  CartLineProvider,
  CartLineQuantityAdjustButton,
  CartCost,
  CartCheckoutButton,
  CartLineQuantity,
} from '@shopify/hydrogen-react'

import { motion } from 'motion/react'
import { ResponsiveImage } from '../ResponsiveImage'
import { ProductTags } from 'components/Product/ProductTags'

export const ItemsTab = ({ lines, status }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
      className="relative flex max-h-[80vh] flex-1 flex-col justify-between md:max-h-[55vh]"
    >
      <div className="scrollbar-hidden relative flex max-h-[220px] flex-1 flex-col justify-between gap-8 overflow-scroll overscroll-auto md:max-h-[350px]">
        {lines?.map((line) => {
          if (!line) return null
          const customImage = line.attributes?.find(
            (attribute) => attribute.key === 'Image'
          )
          const isPreorder = booleanStringIsTruthy(
            line.merchandise?.product?.preorder?.value
          )
          const isBackorder = booleanStringIsTruthy(
            line.merchandise?.product?.backorder?.value
          )

          return (
            <CartLineProvider line={line} key={line.id}>
              <div className="flex items-start justify-between rounded-8 bg-white p-8 text-13 leading-100">
                <div
                  className="relative mr-14 h-[100px] w-auto overflow-hidden rounded-6"
                  style={{
                    aspectRatio: `${line.merchandise?.image?.width} / ${line.merchandise?.image?.height}`,
                  }}
                >
                  <ResponsiveImage
                    src={customImage?.value ?? line.merchandise?.image?.url}
                    alt={line.merchandise?.image?.altText ?? ''}
                    position="right"
                  />
                </div>
                <div className="flex flex-1 flex-col gap-4 pr-20 pt-8">
                  <ProductTags
                    isPreorder={isPreorder}
                    isBackorder={isBackorder}
                    discountAmount={
                      line.merchandise?.product?.discountAmount?.value
                    }
                    className="pb-4"
                  />
                  <div>{line.merchandise?.product?.title}</div>
                  {line.merchandise?.selectedOptions?.map((option) => {
                    if (!option) return null
                    return (
                      <div key={option.name}>
                        {option.name}: {option.value}
                      </div>
                    )
                  })}
                  <div>{formatCurrency(line.cost?.totalAmount?.amount)}</div>
                </div>
                <div className="background-blur flex rounded-8 p-4 text-11 leading-110">
                  <CartLineQuantityAdjustButton
                    className={
                      status === 'updating' ? 'cursor-wait' : 'cursor-pointer'
                    }
                    adjust="decrease"
                  >
                    <div className="px-12 py-10">-</div>
                  </CartLineQuantityAdjustButton>
                  <div className="px-12 py-10">
                    <CartLineQuantity className="w-12" />
                  </div>
                  <CartLineQuantityAdjustButton
                    className={
                      status === 'updating' ? 'cursor-wait' : 'cursor-pointer'
                    }
                    adjust="increase"
                  >
                    <div className="px-12 py-10">+</div>
                  </CartLineQuantityAdjustButton>
                </div>
              </div>
            </CartLineProvider>
          )
        })}
      </div>
      {lines.length >= 1 ? (
        <div className="flex justify-between pt-38 text-midGray">
          <div>
            <div>Subtotal</div>
            <p className="max-w-[300px] pt-12 text-13 leading-110">
              Sending from the U.S. No extra import duties. Sales tax will be
              calculated at checkout.
            </p>
          </div>
          <CartCost amountType="subtotal" />
        </div>
      ) : (
        <div>Your cart is empty</div>
      )}
      <div className="flex justify-between pt-32">
        <CartCheckoutButton
          className={`me:py-38 w-full rounded-8 bg-yellow py-[28px] text-16 uppercase leading-110 ${
            lines.length <= 0
              ? 'cursor-not-allowed'
              : status === 'updating'
              ? 'cursor-wait'
              : 'cursor-pointer'
          }`}
          disabled={lines.length === 0}
        >
          Checkout
        </CartCheckoutButton>
      </div>
    </motion.div>
  )
}
